/* Al Fagr - 'complete the set' upsell (shirt -> pants, pants -> shirts, max 3) */
(function () {
  'use strict';
  if (window.FagrRecs) return;
  var D = document;
  var F = function () { return window.FagrShop; };
  function urlFor(pid, opts) {
    if (opts && opts.url) return Promise.resolve(opts.url);
    var s = D.querySelector('script[data-pd-p]');
    if (s) { try { var P = JSON.parse(s.textContent); if (String(P.id) === String(pid)) return Promise.resolve(P.u); } catch (e) {} }
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var it = c.items.filter(function (i) { return String(i.product_id) === String(pid); })[0];
      return it && it.url.split('?')[0];
    });
  }
  function load(el, pid, opts) {
    opts = opts || {};
    if (!el || !pid) return Promise.resolve(false);
    return urlFor(pid, opts).then(function (u) {
      if (!u) throw 0;
      return fetch(u + (u.indexOf('?') > -1 ? '&' : '?') + 'section_id=fagr-pair').then(function (r) { return r.ok ? r.text() : ''; });
    }).then(function (t) {
      var d = new DOMParser().parseFromString(t, 'text/html');
      var rc = d.querySelector('[data-rc]');
      if (!rc || !rc.querySelector('[data-rc-item]')) { el.innerHTML = ''; el.hidden = true; return false; }
      el.innerHTML = ''; el.appendChild(rc); el.hidden = false; return true;
    }).catch(function () { el.hidden = true; return false; });
  }
  D.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rc-add]');
    if (!b || !F()) return;
    e.preventDefault();
    var it = b.closest('[data-rc-item]');
    var sel = it.querySelector('[data-rc-sel]');
    var id = sel && +sel.value;
    if (!id) return;
    var old = b.innerHTML; b.disabled = true;
    F().Cart.add([{ id: id, quantity: 1 }]).then(function () {
      b.classList.add('is-ok'); b.textContent = F().T('Added ✓', 'تمت ✓');
    }).catch(function (er) {
      b.classList.add('is-err'); b.textContent = (er && er.message) || F().T('Error', 'خطأ');
    }).then(function () { setTimeout(function () { b.disabled = false; b.classList.remove('is-ok', 'is-err'); b.innerHTML = old; }, 1600); });
  });
  window.FagrRecs = { load: load };
})();
